import Api from './Api'

export default {
    getAll() {
        return Api().post(`categories/all`);
    },
}